import React, { useEffect, useState } from 'react'
import retailBanner from '../assets/images/retailBanner.jpg'
import retailBannerMobile from '../assets/images/retailBannerMobile.jpg'
import { Link } from 'react-router-dom';
import Layout from './layout';
import lakeView from '../assets/images/lakeviewLogo.svg'
import jetlinx from '../assets/images/jetlinxLogo.svg'
import HomeTestimonial from '../components/HomeTestimonial';
import owenerImage from '../assets/images/owner.jpg';
import bgCover_cle from '../assets/images/bgCover_cle.png';
import axios from 'axios';
import config from '../../src/config';

const CommercialRetail = () => {
  const services = [
    {
      title: "Project Management",
      description: "Our team includes skilled project managers, superintendents, project coordinators, and board-certified architects. We handle every aspect from start to finish."
    },
    {
      title: "Efficient Operations",
      description: "Our project coordinators support subcontractors and maintain subcontractors. We provide weekly project status reports to keep clients informed."
    },
    {
      title: "Permit Handling",
      description: "Our permit expeditors navigate the permitting process across different cities to obtain necessary approvals quickly."
    },
    {
      title: "Design Coordination",
      description: "Our design coordinator works directly with designers to ensure every detail is accounted for and your project comes to life exactly as envisioned."
    },
    {
      title: "On-Site Supervision",
      description: "Dedicated superintendents oversee the project, ensuring timely delivery and maintaining clean, organized conditions."
    }
  ];
  const [projects, setProjects] = useState([]);
  const [categories, setCategories] = useState([])
  const [activeCategory, setActiveCategory] = useState('');

  const fetchCategory = async () => {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/admin/categories`, {
        withCredentials: true
      });
      console.log('response.data', response.data)
      const list = response?.data?.data || [];
      setCategories(list);
      
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };
  useEffect(() => {
    const fetchAndFilterProjects = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/api/admin/get-projects`, {
          withCredentials: true
        });
        const all = response?.data || [];
        const filtered = all.filter(p => Array.isArray(p.category) && p.category.some(name => typeof name === 'string' && /(commercial|retail)/i.test(name)));
        setProjects(filtered);
        // setProjects(...projects,response?.data);
        //  setProjects(...projects,response?.data);
      } catch (err) {
        console.error('Error fetching projects', err);
      }
    };
    fetchAndFilterProjects();
  }, []);
  return (
    <Layout>
      <div className="half-overlay-banner retail-page-banner retail-banner color-light position-relative">
        <picture className="w-100 bottom-overlay position-absolute w-100 h-100">
          <source media="(max-width:768px)" srcSet={retailBannerMobile} />
          <img className="cover" src={retailBanner} alt="" />
        </picture>
        <div className='contant-box d-flex position-absolute w-100 h-100 top-0 start-0'>
          <div className="left-block d-flex flex-column justify-center">
            <div className="summary">
              <div className='font-11 font-medium text-uppercase mb-10'>COMMERICAL</div>
              <h2 className='mb-25'>Miami’s premier design build firm for retail and commercial</h2>
              <Link to='/contact' className='button button-blur light-border mt-25'>CONTACT US</Link>
            </div>

          </div>
          <div className="right-block h-100 d-flex align-end py-60 d-px-120 py-60">
          </div>
        </div>
      </div>

      <div className='recent-clients-section bg-black pt-50 pb-50 color-light'>
        <div className='container'>
          <div className='grid-blocks d-grid d-column-2 gap-150'>
            <div className='grid-block'>
              <div className='summary-block'>
                <h2 className='mb-20'>Why work with Ivey Design Build for retail and commercial fit out?</h2>
                <p>Engaging a high-end design firm for a retail or commercial fit-out is crucial for creating a space that not only reflects a brand’s identity but also enhances customer experience and operational efficiency. These firms bring a deep understanding of spatial planning, material selection, and modern aesthetics, ensuring the final environment is both visually impactful and functionally optimized. Their expertise in managing complex projects—from concept to completion—reduces costly delays and ensures that the fit-out meets industry standards and client expectations. Ultimately, a high-end design firm elevates the space into a strategic asset that drives engagement, loyalty, and business success.</p>
              </div>
            </div>
            <div className='grid-block'>
              <div className='title-block'>
                <div className='font-11 font-medium text-uppercase mb-10'>RECENT CLIENTS</div>
              </div>
              <div className='client-block d-flex'>
                <div className='logo-block'><img src={jetlinx} /></div>
                <div className='logo-block'><img src={lakeView} /></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <HomeTestimonial contentHide={true} />
      <section className="services-section" style={{ backgroundImage: `url(${bgCover_cle})` }}>
        <div className="services-overlay">
          <div className="services-container">
            <h2 className="services-title">SERVICES</h2>
            <div className="services-grid">
              {services.map((service, index) => (
                <div key={index} className="service-item">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

      </section>
      <section className="p-recent-projects-section">
        <div className="p-projects-container">
          <div className="p-projects-header">
            <h2 >Recent commercial and <br /> retail projects</h2>

            {/* <h2 className="p-projects-main-title">Recent commercial and retail projects</h2> */}
          </div>

          <div className="p-projects-grid">
            {projects?.slice(0,2).map((project) => (
              <div key={project.slug || project._id} className="p-project-card">
                <div className="p-project-image-wrapper">
                  <img
                    src={`${config.BASE_URL}${project.featuredImage}`}
                    alt={project.title}
                    className="p-project-image"
                  />
                </div>

                <div className="p-project-content">
                  <h3>{project?.title}</h3>
                  <p>{project?.description}</p>
                  {/* {project.location || project.space ? (
                    <p>{project.location}{project.location && project.space ? ' · ' : ''}{project.space ? `${project.space} sq ft` : ''}</p>
                  ) : null} */}
                  <Link to={`/single-project/${project.slug}`} className="p-project-more-link">
                    MORE
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>

      </section>


      <section className="p-testimonial-section">
        <div className="p-testimonial-container">
          {/* Left side - Dark with text */}
          <div className="p-testimonial-content">
            <div className="p-testimonial-text-wrapper text-white p-owner-section">
              {/* <blockquote className="p-testimonial-quote">
                "A seamless experience from start to finish..."
              </blockquote> */}
              <h2>
                "A seamless experience from start to finish..."
              </h2>
              <p >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                aliquip ex ea commodo consequat.
              </p>

              {/* <button className="button button-blur text-white">
                VIEW PROJECTS
              </button> */}
              {/* <Link to='' className='button button-blur text-white light-border mt-25'><span>VIEW PROJECTS </span></Link> */}
              <div className="summary">
                {/* <div className='font-11 font-medium text-uppercase mb-10'>COMMERICAL</div> */}
                {/* <h2 className='mb-25'>Miami’s premier design build firm for retail and commercial</h2> */}
                <Link to='/projects' className='button button-blur2 text-white light-border mt-25'>VIEW PROJECTS</Link>
              </div>
            </div>
          </div>

          {/* Right side - Image */}
          <div className="p-testimonial-image-section">
            <div className="p-testimonial-image-wrapper">
              <img owenerImage
                src={owenerImage}
                alt="Business professionals in showroom"
                className="p-testimonial-image"
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default CommercialRetail